export class CustomResponse {
    constructor(
        public responseMessage: string,
        public isAuthenticated: boolean
    ) { }
}
